<template>
  <div class="container my-5">
    <!-- Zurück-Button zum Hauptmenü -->
    <button @click="goBack" class="btn btn-secondary mb-3">
      <font-awesome-icon icon="arrow-left" /> Zurück zum Hauptmenü
    </button>

    <h2 class="text-center mb-4">Kunden Menü</h2>
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-4 mb-4">
        <div class="modern-tile">
          <router-link to="/customers/create" class="tile-content">
            <font-awesome-icon icon="user-plus" class="tile-icon" />
            <span>Kunden anlegen</span>
          </router-link>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-4 mb-4">
        <div class="modern-tile">
          <router-link to="/customers/overview" class="tile-content">
            <font-awesome-icon icon="users" class="tile-icon" />
            <span>Kunden Übersicht</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerMenu',
  methods: {
    goBack() {
      this.$router.push('/mainmenu'); // Geht zurück zum Hauptmenü
    },
  },
};
</script>

<style scoped>
/* Stil für den Zurück-Button */
.btn {
  margin-bottom: 20px;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 8px;
}

/* Modernes Design für Kacheln */
.modern-tile {
  background-color: var(--primary-color); /* Verwende die Primärfarbe */
  color: white;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  position: relative;
}

.tile-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: white;
}

.tile-content span {
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
}

.tile-icon {
  font-size: 48px;
}

.modern-tile:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2);
}
</style>
